import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../../route/RouteHelper";
import {useState} from "react";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import ResidenceManagerBasicInfo from "./ResidenceManagerBasicInfo";
import ChangeUserName from "../../../component/ChangeUserName/ChangeUserName";
import {ResidencesManagerService} from "../../../serverService/residencesManagerService/ResidencesManagerService";
import ChangePasswordCardComponent from "../../../component/changePassword/ChangePasswordCardComponent";
import {ManagerBanAccess} from "../../../component/manangerDetail/ManagerBanAccess";

export default function ResidenceManagerInfo() {
    const navigate = useNavigate()
    const {state} = useLocation();
    const [searchParams] = useSearchParams();
    const title = searchParams.get("title");

    const service = new ResidencesManagerService()

    const {id: residenceManagerId = -1} = useParams()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : title ? title : RouteHelper.ResidencesManager.name);

    const [tabSelectedValue, setTabSelectedValue] = useState(ClerkTabType.Profile.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    function getDataFromServer() {

    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Habitation.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.ResidencesManager.name,
                                RouteHelper.ResidencesManager.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            ),
                        ]}
                    />
                    <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                        if (window.history.length > 2) {
                            navigate(-1);
                        } else {
                            navigate(RouteHelper.ResidencesManager.globalUrl);
                        }
                    }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={ClerkTabType.Profile.title}
                                value={ClerkTabType.Profile.id}/>

                            <Tab
                                label={ClerkTabType.Username.title}
                                value={ClerkTabType.Username.id}/>

                            <Tab
                                label={ClerkTabType.Password.title}
                                value={ClerkTabType.Password.id}/>
                            <Tab
                                label={ClerkTabType.BanAccess.title}
                                value={ClerkTabType.BanAccess.id}/>
                        </TabList>
                    </Box>
                    <TabPanel value={ClerkTabType.Profile.id}>
                        <ResidenceManagerBasicInfo residenceManagerId={residenceManagerId}/>
                    </TabPanel>
                    <TabPanel value={ClerkTabType.Username.id}>
                        <ChangeUserName
                            service={service}
                            hint={"بعد از تغییر نام کاربری، خادم مربوطه می بایست مجددا با نام کاربری جدید وارد سامانه شود ."}
                            adminId={residenceManagerId}
                            refreshDetailInfo={_ => {
                                getDataFromServer()
                            }}
                        />
                    </TabPanel>
                    <TabPanel value={ClerkTabType.Password.id}>
                        <ChangePasswordCardComponent
                            adminId={residenceManagerId}
                            service={service}
                            doChangePassword={() => {
                            }}
                        />
                    </TabPanel>
                    <TabPanel value={ClerkTabType.BanAccess.id}>
                        <ManagerBanAccess
                            managerId={residenceManagerId}
                            service={service}
                        />
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>

        </RaikoBaseContainer>
    )
}
const ClerkTabType = {
    Profile: {
        id: "profile",
        title: "جزئیات حساب "
    },
    Username: {
        id: "user-name",
        title: "نام کاربری"
    },
    Password: {
        id: "password",
        title: "رمز عبور"
    },
    BanAccess: {
        id: "ban-access",
        title: "مسدود سازی"
    },
}